import { useContext } from "react"
import UiContext from "../context/uiProvider"


export default function useDevice() {
  const { deviceView } = useContext(UiContext)
  return deviceView
}